export enum LookupMacros {
  CurrentUser = '@Bruger',
  UserTeam = '@Team',
  ServiceProvider = '@Udførerenheder',
}

export enum CodeListTypesForLookupMacros {
  ServiceProvider = 'socialproviderunit',
  ServiceProviders = 'socialproviderunits',
}
